import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactInfo = () => {
  const contactMethods = [
    {
      icon: 'Phone',
      title: 'Phone',
      content: '+2342013309313',
      description: 'Mon-Fri: 9:00 AM - 6:00 PM (WAT)',
      action: 'tel:+2342013309313'
    },
    {
      icon: 'Mail',
      title: 'Email',
      content: 'comfort@cultaz.com',
      description: 'Business & support enquiries - reply within 24 hours',
      action: 'mailto:comfort@cultaz.com'
    },
    {
      icon: 'MessageCircle',
      title: 'WhatsApp',
      content: 'Join our WhatsApp channel',
      description: 'Fast updates and support via WhatsApp',
      action: 'https://whatsapp.com/channel/0029Vafll5L11ulW2CLfCd0D'
    }
  ];

  const businessHours = [
    { day: 'Monday - Friday', hours: '8:00 AM - 6:00 PM' },
    { day: 'Saturday', hours: '9:00 AM - 2:00 PM' },
    { day: 'Sunday', hours: 'Closed' }
  ];

  return (
    <div className="space-y-6 md:space-y-8">
      <div className="bg-card rounded-2xl shadow-purple-lg border border-border p-6 md:p-8">
        <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground mb-6">
          Contact Information
        </h3>

        <div className="space-y-6">
          {contactMethods?.map((method, index) => (
            <div key={index} className="flex items-start space-x-4">
              <div className="flex-shrink-0 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">
                <Icon name={method?.icon} size={24} color="var(--color-primary)" strokeWidth={2} />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-body text-base md:text-lg font-semibold text-foreground mb-1">
                  {method?.title}
                </h4>
                {method?.action ? (
                  <a
                    href={method?.action}
                    className="font-body text-base text-primary hover:text-primary/80 transition-smooth break-all"
                  >
                    {method?.content}
                  </a>
                ) : (
                  <p className="font-body text-base text-foreground">
                    {method?.content}
                  </p>
                )}
                <p className="font-body text-sm text-muted-foreground mt-1">
                  {method?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-card rounded-2xl shadow-purple-lg border border-border p-6 md:p-8">
        <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground mb-6">
          Business Hours
        </h3>

        <div className="space-y-4">
          {businessHours?.map((schedule, index) => (
            <div key={index} className="flex items-center justify-between py-3 border-b border-border last:border-0">
              <span className="font-body text-base text-foreground">
                {schedule?.day}
              </span>
              <span className="font-body text-base text-muted-foreground font-medium whitespace-nowrap">
                {schedule?.hours}
              </span>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-gradient-to-br from-primary/10 to-secondary/10 rounded-2xl border border-primary/20 p-6 md:p-8">
        <div className="flex items-start space-x-4">
          <div className="flex-shrink-0 flex h-12 w-12 items-center justify-center rounded-lg bg-primary/20">
            <Icon name="Headphones" size={24} color="var(--color-primary)" strokeWidth={2} />
          </div>
          <div>
            <h4 className="font-heading text-lg md:text-xl font-bold text-foreground mb-2">
              Need Immediate Support?
            </h4>
            <p className="font-body text-sm md:text-base text-muted-foreground mb-4">
              Our technical support team is available to help with any urgent issues or questions about your Cultaz system.
            </p>
            <a
              href="/support-faq"
              className="inline-flex items-center space-x-2 font-body text-sm md:text-base font-medium text-primary hover:text-primary/80 transition-smooth"
            >
              <span>Visit Support Center</span>
              <Icon name="ArrowRight" size={16} color="currentColor" strokeWidth={2} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;